export default __webpack_public_path__ + "static/media/0.97740c55.svg";